import React from 'react';
import PropTypes from 'prop-types';
import LocalizedLink from 'helpers/LocalizeLink';
import Picture from 'components/elements/Picture';
import { useSelector } from 'react-redux';

function TextImageRightWidget(props) {
    const auth = useSelector(store => store.auth);

    if (!props?.title && !props?.descriptions && !props?.additional_text && !props?.button_text && !props?.link && !props?.img && !props?.img_mob) return null;

    return (
        <div data-test-id="tir-wr" className={"widget widget-textimageright" + (props?.dark ? " bg-dark" : "")}>
            <div className="container-xl row mx-auto p-0">
                <div className="text-sm-center col-12 col-md-5 col-lg-6">
                    {props?.title ? <h2 data-test-id="tir-title" className="text-color-changeable mb-20">{props.title}</h2> : null}
                    {props?.descriptions ? <p data-test-id="tir-description" className={(props?.dark ? 'text-white ' : '') + "text-sm-medium text-semibold mb-20"}>{props.descriptions}</p> : null}
                    {props?.additional_text ? <p data-test-id="tir-add-text" className="text-color-changeable text-semibold text-sm-medium text-italic mb-20">{props.additional_text}</p> : null}
                    {
                        props?.button_text && props?.link ?
                            auth && (props.link === '/auth' || props.link === 'auth') ?
                                <LocalizedLink dti="tir-btn" to={'/price'} className={"btn h-42 px-12" + (props?.dark ? ' btn-dark' : '')}>
                                    {props.button_text}
                                </LocalizedLink>
                                :
                                <LocalizedLink dti="tir-btn" to={props.link ? props.link : null} className={"btn h-42 px-12" + (props?.dark ? ' btn-dark' : '')}>
                                    {props.button_text}
                                </LocalizedLink>
                            : null
                    }
                </div>
                {
                    props?.img?.source || props?.img_mob?.source ?
                        <div className="col-12 col-md-7 col-lg-6">
                            <Picture dti="tir-img" img={props.img} img_mob={props.img_mob} className='w-100' />
                        </div>
                        :
                        null
                }
            </div>
        </div>
    )
}

TextImageRightWidget.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string,
    additional_text: PropTypes.string,
    button_text: PropTypes.string,
    link: PropTypes.string,
    path: PropTypes.string,
    img: PropTypes.object,
    position: PropTypes.number,
    widget: PropTypes.string,
    className: PropTypes.string,
};

export default TextImageRightWidget;
